import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import SearchBar from '../components/SearchBar';
import JobList from '../components/JobList';
import Hero from '../components/hero';
import Testimonials from '../components/testimonials';
import News from '../components/news';
import Sections from "../components/pricing/pricing";


const Home = () => {
  const [jobs, setJobs] = useState([
    { id: 1, title: 'Frontend Developer', company: 'Google', location: 'New York, NY', type: 'Full-time' },
    { id: 2, title: 'Backend Developer', company: 'Amazon', location: 'Seattle, WA', type: 'Full-time' },
    // Add more dummy jobs
  ]);

  const handleSearch = (filters) => {
    // Update job list based on filters
    console.log('Searching with filters:', filters);
  };

  return (
    <div>
      <Navbar />
    


      <SearchBar onSearch={handleSearch} />
      <Hero/>
      {/* <JobList jobs={jobs} /> */}
      <Sections />

      <Testimonials/>
      <News/>
      
    </div>
  );
};

export default Home;
